import { render, staticRenderFns } from "./MatchListPage.vue?vue&type=template&id=1a124926&"
import script from "./MatchListPage.vue?vue&type=script&lang=js&"
export * from "./MatchListPage.vue?vue&type=script&lang=js&"
import style0 from "./MatchListPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports